import { Dropdown, Popup } from '@creditsights/styleguide-web';
import { orderBy } from 'lodash';
import { ReactElement, useEffect, useState } from 'react';
import { NavLink } from 'react-router-dom';
import useFetchAnalysts from '../../hooks/analysts/useFetchAnalysts';
import './Team.scss';

function Team(): ReactElement {
  const { data: team } = useFetchAnalysts();
  const [teamType, setTeamType] = useState<any>('all');
  const [analysts, setAnalysts] = useState<any[]>([]);

  const options = [
    {
      key: 'all',
      text: 'All',
      value: 'all',
    },
    {
      key: 'research',
      text: 'CS Research',
      value: 'Research',
    },
    {
      key: 'News',
      text: 'Covenants Lawyers',
      value: 'Covenants',
    },
    {
      key: 'Covenants',
      text: 'LFI Editorial Team',
      value: 'News',
    },
  ];

  useEffect(() => {
    if (team) {
      let array: any[] = [];
      if (teamType !== 'all') {
        for (const analyst of team) {
          for (const position of analyst.positions) {
            if (position.department === teamType) {
              array.push({
                ...analyst,
                order: position.order,
              });
              break;
            }
          }
        }

        array = orderBy(array, ['order', 'displayName'], ['asc', 'asc']);
      } else {
        array = orderBy(team, ['displayName'], ['asc']);
      }

      setAnalysts([]);
      setTimeout(() => setAnalysts(array), 100);
    }
  }, [team, teamType]);

  return (
    <div className="cs-team-ctx">
      <div className="title">Our Team</div>
      <div className="description">
        Teamwork is a hallmark of the CreditSights approach, allowing us to fully leverage the experience of our senior staff while benefiting from the innovation and fresh perspective that comes from our more junior team members. Meet the team that
        makes CreditSights such a great place to work.
      </div>
      <div className="table-ctx">
        <div className="header-ctx">
          <div className="message">Meet The Team</div>
          <div className="separator" />
          <div className="dropdown-ctx">
            <div className="label">Showing:</div>
            <Dropdown fluid value={teamType} options={options} onOptionSelect={(value) => setTeamType(value)} />
          </div>
        </div>
        <div className="table">
          <table className="ui table">
            <thead>
              <tr>
                <th>Name</th>
                <th>Title</th>
                <th>Team</th>
                <th>Location</th>
                <th />
              </tr>
            </thead>
            <tbody>
              {analysts &&
                analysts.map((analyst) => (
                  <tr key={analyst.tagId}>
                    <td>
                      <div className="name">
                        {analyst.imageUrl && <img src={analyst.imageUrl} loading="lazy" alt="" />}
                        {!analyst.imageUrl && <div className="no-image">{analyst.initials}</div>}
                        {analyst.hasBio && <NavLink to={`/analysts/${analyst.tagId.replace('analyst/', '')}`}>{analyst.displayName}</NavLink>}
                        {!analyst.hasBio && <Popup content="Profile page not available" basic={false} position="right center" trigger={<span>{analyst.displayName}</span>} />}
                      </div>
                    </td>
                    <td>{analyst.role}</td>
                    <td>
                      {analyst.positions.map((position) => (
                        <div key={position.department}>{position.department}</div>
                      ))}
                    </td>
                    <td>{analyst.location}</td>
                    <td className="linkedInUrl">
                      {analyst.linkedInUrl && (
                        <a href={analyst.linkedInUrl} target="_blank" rel="noreferrer">
                          <i className="linkedin icon" />
                        </a>
                      )}
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

export default Team;
